"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var initializeSignatureContent_1 = require("../actions/initializeSignatureContent");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_options_controls_1 = require("owa-options-controls");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var SignatureEditor_1 = require("./SignatureEditor");
var toggleSignatureSetting_1 = require("../actions/toggleSignatureSetting");
var SignatureFull = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureFull, _super);
    function SignatureFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignatureFull.prototype.componentDidMount = function () {
        initializeSignatureContent_1.default();
    };
    SignatureFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_signature_title),
            React.createElement(SignatureEditor_1.default, null),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_signature_signNewMails, checked: owa_options_core_1.getFallbackValueIfNull(optionStore.signNewMails, userOptions.AutoAddSignature), onChange: this.onSignNewEmailsClicked }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_signature_signReplies, checked: owa_options_core_1.getFallbackValueIfNull(optionStore.signReplies, userOptions.AutoAddSignatureOnReply), onChange: this.onSignRepliesClicked })));
    };
    SignatureFull.prototype.onSignNewEmailsClicked = function (ev, checked) {
        toggleSignatureSetting_1.default('signNewMails', checked);
    };
    SignatureFull.prototype.onSignRepliesClicked = function (ev, checked) {
        toggleSignatureSetting_1.default('signReplies', checked);
    };
    SignatureFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], SignatureFull);
    return SignatureFull;
}(React.Component));
exports.default = SignatureFull;
//# sourceMappingURL=SignatureFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/components/SignatureFull.js
// module id = 5006
// module chunks = 2